import constants from "@core/config/constants.js";
const { USAGE_CHART_COLORS } = constants;

export default {
  name: "UsageMixin",
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      statsKey: ""
    };
  },
  /**
  |--------------------------------------------------
  | Computed properties
  |--------------------------------------------------
  */
  computed: {
    /**
     * Donout chart backgound colors
     */
    _backgroundColors() {
      const [usagePercent] = this._usageChartData;
      const { usage, pending, overage } = USAGE_CHART_COLORS;

      return [usagePercent >= 100 ? overage : usage, pending];
    },
    /**
     * Computes the usage to be dsiplayed in donut chart
     */
    _usageChartData() {
      const { allocated, used } = this[this.statsKey];
      const { calculatePercentage } = this.$options.filters;

      const pendingQuota = allocated - used;
      let allocatedPercent =
        pendingQuota < 0 ? 0 : calculatePercentage(pendingQuota, allocated);

      const utilizedPercent = calculatePercentage(used, allocated);
      const hasUnallocated = utilizedPercent === 0 && allocatedPercent === 0;

      if (hasUnallocated) {
        allocatedPercent = 100;
      }

      return [utilizedPercent, allocatedPercent];
    }
  }
};
